import Typography from "typography";
import bootstrapTheme from "typography-theme-bootstrap";

const typography = new Typography(bootstrapTheme);

export default typography;


// WEBPACK FOOTER //
// ./src/utils/typography.js